import { api_get, api_post, stringfy_post } from '../../../utils/http'

const baseUri = '/search/api'

/**
 * 1.CMS资源检索
 */
function cmsResource(params: any) {
  return stringfy_post(baseUri + '/cms_resource/search', params)
}
/*
 * 3.查询试卷文档
 */
function cmsDownload(params: any) {
  return api_post(baseUri + '/cms_resource/download', params)
}

/**
 * 7.获取过滤参数
 */
function filterData(params: any) {
  return api_get(baseUri + '/cms_resource/cms_constant', params)
}

function bookCatalog(params: any) {
  return api_post(baseUri + '/book/catalog', params)
}
// 获取教材信息
function bookSeries(params: any) {
  return api_post(baseUri + '/book/series', params)
}

function getBooks(params: any) {
  return api_post(baseUri + '/book/get_books', params)
}

function recordBook(params: any) {
  return api_post(baseUri + '/book/record_book', params)
}

/**
 * 8.获取用户已有的下载券数量
 */
function getCouponCount(params: any) {
  return api_get(baseUri + '/personal/membership/coupon-num', params)
}

// cms白名单列表，判断当前用户是否有此权限
function getIsCmsAdmin(params: any) {
  return api_get(baseUri + '/cms_resource/is_cms_admin', params)
}
// 获取知识点树
function knowledgeManage(params: any) {
  return api_post(baseUri + '/knowledge_point/knowledge_point_manage', params)
}
export {
  cmsResource,
  cmsDownload,
  filterData,
  bookCatalog,
  getBooks,
  bookSeries,
  recordBook,
  getCouponCount,
  getIsCmsAdmin,
  knowledgeManage
}
